export const RARE_LETTERS = ['J', 'X', 'Z', 'Q'] as const
export const RARE_LETTER_SET = new Set<string>(RARE_LETTERS)

export const BOGGLE_LETTER_WEIGHTS = {
  consonants: [
    ['T', 8],
    ['S', 7],
    ['N', 6],
    ['R', 6],
    ['H', 4],
    ['D', 4],
    ['L', 4],
    ['G', 4],
    ['C', 3],
    ['M', 3],
    ['F', 3],
    ['P', 3],
    ['Y', 3],
    ['W', 2],
    ['B', 2],
    ['V', 2],
    ['K', 2],
    ['J', 1],
    ['X', 1],
    ['Q', 1],
    ['Z', 1],
  ],
  vowels: [
    ['A', 8],
    ['E', 12],
    ['I', 7],
    ['O', 7],
    ['U', 4],
  ],
} as const

const FLATTENED_LETTER_WEIGHTS = flattenBoggleLetterWeights(BOGGLE_LETTER_WEIGHTS)
const LETTER_WEIGHT_BY_LETTER = new Map(
  FLATTENED_LETTER_WEIGHTS.map(([letter, weight]) => [letter, weight]),
)

export function flattenBoggleLetterWeights(
  source: typeof BOGGLE_LETTER_WEIGHTS = BOGGLE_LETTER_WEIGHTS,
): Array<readonly [string, number]> {
  return [...source.vowels, ...source.consonants].map(
    ([letter, weight]) => [letter, weight] as const,
  )
}

export function getBoggleLetterWeight(letter: string): number {
  return LETTER_WEIGHT_BY_LETTER.get(letter.toUpperCase()) ?? 0
}
